var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _rect, _rect2, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _rect3, _path29, _path30, _path31, _path32, _path33, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHowTamperProofWorksBg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1442,
    height: 1794,
    viewBox: "0 0 1442 1794",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1441 1794H1V64H1441V1794Z",
    fill: "#6D2FEC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M480.991 571L0.991156 809",
    stroke: "white",
    strokeOpacity: 0.4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M560.993 571L283.865 809L283.865 1158.5",
    stroke: "white",
    strokeOpacity: 0.4
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M284.492 809L561.994 571L640.992 571L513.991 808.5L513.991 1159.5L284.492 1159.5L284.492 809Z",
    fill: "url(#paint0_linear_2652_30016)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M640.992 571L512.377 809L512.377 1151.5",
    stroke: "white",
    strokeOpacity: 0.4
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M720.991 571V809V1007.5",
    stroke: "white",
    strokeOpacity: 0.4
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M800.993 571L929.609 809L929.614 1165.5",
    stroke: "white",
    strokeOpacity: 0.4
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M880.993 571L1158.12 809L1158.13 1157",
    stroke: "white",
    strokeOpacity: 0.4
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M1157.49 809L880.992 571L801.991 571L929.992 809L929.994 1162L1157.49 1162L1157.49 809Z",
    fill: "url(#paint1_linear_2652_30016)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M960.991 571L1440.99 809",
    stroke: "white",
    strokeOpacity: 0.4
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M1.00195 809L1441 809",
    stroke: "white",
    strokeOpacity: 0.4
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M160.602 729.865L1281.4 729.865",
    stroke: "white",
    strokeOpacity: 0.4
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M240.991 690L1200.99 690",
    stroke: "white",
    strokeOpacity: 0.4
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M321.392 650.135L1120.59 650.135",
    stroke: "white",
    strokeOpacity: 0.4
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M400.591 610.865L1041.39 610.865",
    stroke: "white",
    strokeOpacity: 0.4
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 521,
    width: 1440,
    height: 145,
    fill: "url(#paint2_linear_2652_30016)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 809,
    width: 1440,
    height: 378,
    fill: "url(#paint3_linear_2652_30016)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M961 394L1441 156",
    stroke: "white",
    strokeOpacity: 0.2
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M880.998 394L1158.13 156L1158.13 77",
    stroke: "white",
    strokeOpacity: 0.2
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M800.999 394L929.615 156L929.615 84",
    stroke: "white",
    strokeOpacity: 0.2
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M721 394L721 156L721 79.5",
    stroke: "white",
    strokeOpacity: 0.2
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M640.998 394L512.382 156L512.382 83.5001",
    stroke: "white",
    strokeOpacity: 0.2
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M560.999 394L283.871 156L283.871 92",
    stroke: "white",
    strokeOpacity: 0.2
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M481 394L0.999913 156",
    stroke: "white",
    strokeOpacity: 0.2
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M1441 156L0.999943 156",
    stroke: "white",
    strokeOpacity: 0.2
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M1360.6 195.865L81.3997 195.865",
    stroke: "white",
    strokeOpacity: 0.2
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M1281.4 235.135L160.6 235.135",
    stroke: "white",
    strokeOpacity: 0.2
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M1201 275L241 275",
    stroke: "white",
    strokeOpacity: 0.2
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M1120.6 314.865L321.4 314.865",
    stroke: "white",
    strokeOpacity: 0.2
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M1041.4 354.135L400.6 354.135",
    stroke: "white",
    strokeOpacity: 0.2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 1441,
    y: 397,
    width: 1440,
    height: 320,
    transform: "rotate(180 1441 397)",
    fill: "url(#paint4_linear_2652_30016)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M720.9 1243.33C739.309 1243.33 754.233 1228.41 754.233 1210C754.233 1191.59 739.309 1176.67 720.9 1176.67C702.49 1176.67 687.566 1191.59 687.566 1210C687.566 1228.41 702.49 1243.33 720.9 1243.33Z",
    fill: "#6D2FEC",
    fillOpacity: 0.4
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M730.9 1204.1L721.234 1198.53C718.834 1197.13 715.934 1197.13 713.534 1198.53C711.134 1199.93 709.7 1202.4 709.7 1205.2V1216.37C709.7 1219.13 711.134 1221.63 713.534 1223.03C714.734 1223.73 716.067 1224.07 717.367 1224.07C718.7 1224.07 720 1223.73 721.2 1223.03L730.867 1217.47C733.267 1216.07 734.7 1213.6 734.7 1210.8C734.767 1208 733.334 1205.5 730.9 1204.1Z",
    fill: "#6D2FEC"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M1 1510L1441 1510L1441 1474.3C1441 1474.3 1161.5 1444 721 1444C280.5 1444 0.999994 1474.3 0.999994 1474.3L1 1510Z",
    fill: "#6D2FEC"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M1 1794L1441 1794L1441 1758.3C1441 1758.3 1161.5 1728 721 1728C280.5 1728 0.999994 1758.3 0.999994 1758.3L1 1794Z",
    fill: "white"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M1441 64L1 64.0001L0.999997 29.3781C0.999997 29.3781 280.5 0.000101454 721 6.29444e-05C1161.5 2.44347e-05 1441 29.378 1441 29.378L1441 64Z",
    fill: "#6D2FEC"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2652_30016",
    x1: 589.992,
    y1: 576,
    x2: 584.502,
    y2: 873.616,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6D2FEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#793BF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2652_30016",
    x1: 855.992,
    y1: 554,
    x2: 997.459,
    y2: 889.466,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6D2FEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#793BF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2652_30016",
    x1: 721,
    y1: 530,
    x2: 721,
    y2: 666,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.481631,
    stopColor: "#6D2FEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D2FEC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2652_30016",
    x1: 721,
    y1: 832.462,
    x2: 721,
    y2: 1187,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6D2FEC",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.481631,
    stopColor: "#6D2FEC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2652_30016",
    x1: 2161,
    y1: 416.862,
    x2: 2161,
    y2: 717,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.211538,
    stopColor: "#6D2FEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#6D2FEC",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D2FEC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHowTamperProofWorksBg);
export default __webpack_public_path__ + "static/media/HowTamperProofWorksBg.0df5da48bb4b3029e8c5e1189183b34a.svg";
export { ForwardRef as ReactComponent };